import { DemoReadOnlyError, type Repo } from './repo';
import { buildDemoData } from './demoData';

const copy = <T>(v: T): T => JSON.parse(JSON.stringify(v)) as T;
const blocked = async (): Promise<never> => { throw new DemoReadOnlyError(); };

/** Read-only synthetic repository. Imports nothing that can reach the network. */
export function createDemoRepo(now = new Date()): Repo {
  const d = buildDemoData(now);
  return {
    isDemo: true,
    currentUserId: async () => 'demo-user',
    signIn: blocked,
    sendMagicLink: blocked,
    signOut: async () => undefined,
    onAuthChange: () => () => undefined,

    months: async () => copy(d.months),
    ensureMonth: async (monthStart) => {
      const m = d.months.find((x) => x.month_start === monthStart);
      if (!m) throw new DemoReadOnlyError();
      return copy(m);
    },
    categories: async () => copy(d.categories),
    ensureCategory: blocked,
    categoryMonths: async (monthId) => copy(d.categoryMonths[monthId] ?? []),
    transactions: async (monthStart, categoryId) => {
      const rows = d.transactions[monthStart] ?? [];
      const name = categoryId ? d.categories.find((c) => c.id === categoryId)?.name : null;
      return copy(name ? rows.filter((r) => r.category_name === name) : rows);
    },
    accounts: async () => copy(d.accounts),
    capitalPositions: async () => copy(d.positions),
    provisional: async (monthStart) => copy(d.provisional[monthStart] ?? []),

    uploads: async (monthId) => copy(d.uploads[monthId] ?? []),
    reviewItems: async (monthStart) => copy(d.reviewItems[monthStart] ?? []),
    uploadStatement: blocked,
    downloadStatement: blocked,
    supersedeDuplicates: async () => 0,
    matchAlerts: async () => 0,
    importStatement: blocked,
    markUploadFailed: blocked,
    resolveReview: blocked,
    payeeRules: async () => [],
    publishMonth: blocked,
    addQuickCapture: blocked,
    mw: async () => copy(d.mw),
    mwCockpit: async (from) => copy(d.mwCockpit.filter((r) => r.tx_date >= from)),
    addMwCost: blocked,
    addMwPayout: blocked,
    saveMwDeal: blocked,
    saveMwRates: blocked,
    investmentMoves: async () => [],
    addInvestmentMove: blocked,
  };
}
